import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, toMinValue } from "valibot";

export const Route = createFileRoute("/supplier/$supplierId/orders")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Orders")),
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
  }),
  head: () => ({
    meta: seo({ title: "Orders" }),
  }),
});
